import { ColumnConfig, Waffles, WafflesColumn, wafflesKeyColumnName } from "@app/shared/waffles";
import { useImportSidePanel } from "../hooks";
import { JSX } from "react";

interface QueryResultsType {
  [wafflesKeyColumnName]: string;
  [key: string]: unknown;
}

export const ImportQueryResults = (): JSX.Element => {
  const { sidePanel } = useImportSidePanel();

  if (sidePanel.isLoading) { return null; }

  const columnConfig: ColumnConfig = sidePanel.stepDetail.queryResults.headers.reduce((acc, header, index) => {
    acc[index.toString()] = { displayText: header, testId: index.toString() };
    return acc;
  }, {} as { [k: string]: WafflesColumn });
  const data: QueryResultsType[] = sidePanel.stepDetail.queryResults.values.map((recordValues, recordIndex) => {
    const record = recordValues.reduce((acc, value, propIndex) => {
      acc[propIndex.toString()] = value;
      return acc;
    }, {} as QueryResultsType);
    record[wafflesKeyColumnName] = recordIndex.toString();
    return record;
  });

  return (
    <Waffles<QueryResultsType>
      columns={columnConfig}
      data={data}
      loading={sidePanel.isLoading}
      testId="dashboard-specialty-table"
    />
  );
};
